import { LegacyStack, TextField, Text } from "@shopify/polaris";
import { CollectionPicker } from './CollectionPicker.jsx';

const getDestinationQuery = form => {
    const id = form.configuration.origin_collection.id;

    if (! id) {
        return '';
    }

    const chunks = id.split('/');

    return `-id:${chunks[chunks.length - 1]}`;
}

export function FreeOtherCollectionConfiguration ({ form, handleChange, errors }) {
    return (
        <LegacyStack>
            <LegacyStack.Item>
                <LegacyStack vertical>
                    <LegacyStack.Item>
                        {errors['configuration.origin_collection.id'] && (
                            <div>
                                <Text  variant="bodyMd" as="span" tone="critical">{errors['configuration.origin_collection.id']}</Text>
                            </div>
                        )}
                        <CollectionPicker field="origin_collection"
                                          label="Origin Collection"
                                          form={form}
                                          errors={errors}
                                          handleChange={handleChange} />
                    </LegacyStack.Item>
                    {form.configuration.origin_collection.id && (
                        <TextField type="number"
                                   min="1"
                                   step="1"
                                   label="Quantity"
                                   id={`configuration.origin_collection.quantity`}
                                   onChange={handleChange}
                                   error={errors[`configuration.origin_collection.quantity`]}
                                   value={form.configuration.origin_collection.quantity}
                        />
                    )}
                </LegacyStack>
            </LegacyStack.Item>
            <LegacyStack.Item>
                <LegacyStack vertical>
                    <LegacyStack.Item>
                        {errors['configuration.destination_collection.id'] && (
                            <div>
                                <Text  variant="bodyMd" as="span" tone="critical">{errors['configuration.destination_collection.id']}</Text>
                            </div>
                        )}
                        <CollectionPicker field="destination_collection"
                                          label="Destination Collection"
                                          form={form}
                                          errors={errors}
                                          handleChange={handleChange}
                                          query={getDestinationQuery(form)} />
                    </LegacyStack.Item>
                    {form.configuration.origin_collection.id && (
                        <TextField type="number"
                                   min="1"
                                   step="1"
                                   label="Quantity"
                                   id={`configuration.destination_collection.quantity`}
                                   onChange={handleChange}
                                   error={errors[`configuration.destination_collection.quantity`]}
                                   value={form.configuration.destination_collection.quantity}
                        />
                    )}
                </LegacyStack>
            </LegacyStack.Item>
        </LegacyStack>
    );
}
